import React, { useState } from "react";
import {
  FaEnvelope,
  FaUser,
  FaCommentDots,
  FaInstagram,
  FaFacebookF,
  FaLinkedinIn,
  FaXTwitter,
  FaYoutube,
  FaWhatsapp,
} from "react-icons/fa6"; // For modern icons
import ProfileSidebar from "../component/ProfileSidebar";
import BottomMenu from "../component/BottomMenu";
import { FaPhone } from "react-icons/fa";
import { baseurl } from "../baseurl";
import axios from "axios";
import Swal from "sweetalert2";
import PageCount from "../component/utils/PageCount";

const ContactUs = () => {
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    phone: "",
    message: "",
  });
  const [loading, setLoading] = useState(false);

  const handleChange = (key, value) => {
    setFormData((prev) => ({ ...prev, [key]: value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    const Toast = Swal.mixin({
      toast: true,
      position: "top-end",
      showConfirmButton: false,
      timer: 3000,
      timerProgressBar: true,
      customClass: { popup: "swal2-toast-custom" },
    });

    console.log("📤 Sending Data:", formData);

    try {
      const res = await axios.post(`${baseurl}saveContactMessage`, formData);

      console.log("📥 Response:", res.data);

      if (res.data?.success) {
        Toast.fire({
          icon: "success",
          title: "Message submitted successfully!",
        });

        // Clear form
        setFormData({
          name: "",
          email: "",
          phone: "",
          message: "",
        });
      } else {
        Toast.fire({
          icon: "error",
          title: "Something went wrong!",
        });
      }
    } catch (err) {
      console.error("❌ Error submitting form:", err);

      Toast.fire({
        icon: "error",
        title: "Server error. Try again!",
      });
    }

    setLoading(false);
  };

  return (
    <>
      <div className="advanced-search-layout my-bg">
   <PageCount pageName = {"Contact Us"}/>

        <div className="contact-us-content">
          {/* 🌐 CONTACT INFO + SOCIAL SECTION */}
          <div className="contact-info-box shadow-sm mt-4 p-4 text-center mb-3">
            <h4 className="fw-bold mb-3">📞 Need Help?</h4>

            <p className="text-muted mb-1">
              We're here to assist you with any queries related to your account,
              services, billing, or technical support.
            </p>
            <p className="text-muted mb-3">
              Our support team replies within <strong>24 hours</strong>.
            </p>
          </div>

          <div className="contact-header contact-info-box shadow-sm p-3 mb-3">
            <h2>📩 Contact Us</h2>
            <p>Have questions? We’re here to help you.</p>
          </div>

          <div className="contact-form-card shadow-lg p-4">
            <form onSubmit={handleSubmit}>
              <div className="row g-3">
                <div className="col-md-6">
                  <label className="form-label fw-semibold">
                    <FaUser className="me-2 text-theme" /> Full Name
                  </label>
                  <input
                    type="text"
                    className="form-control"
                    placeholder="Enter your full name"
                    value={formData.name}
                    required
                    onChange={(e) => handleChange("name", e.target.value)}
                  />
                </div>

                <div className="col-md-6">
                  <label className="form-label fw-semibold">
                    <FaEnvelope className="me-2 text-theme" /> Email Address
                  </label>
                  <input
                    type="email"
                    className="form-control"
                    placeholder="Enter valid email"
                    value={formData.email}
                    required
                    onChange={(e) => handleChange("email", e.target.value)}
                  />
                </div>

                <div className="col-md-6">
                  <label className="form-label fw-semibold">
                    <FaPhone className="me-2 text-theme" /> Phone Number
                  </label>
                  <input
                    type="tel"
                    className="form-control"
                    placeholder="Enter phone number"
                    maxLength="10"
                    value={formData.phone}
                    required
                    onChange={(e) =>
                      handleChange("phone", e.target.value.replace(/\D/g, ""))
                    }
                  />
                </div>

                <div className="col-12">
                  <label className="form-label fw-semibold">
                    <FaCommentDots className="me-2 text-theme" /> Message
                  </label>
                  <textarea
                    className="form-control"
                    rows="4"
                    placeholder="Write your message..."
                    value={formData.message}
                    required
                    onChange={(e) => handleChange("message", e.target.value)}
                  ></textarea>
                </div>
              </div>

              <div className="text-end mt-4">
                <button
  type="submit"
  className="btn btn-primary d-flex align-items-center justify-content-center"
  disabled={loading}
 
>
  {loading ? (
    <div
      className="spinner-border spinner-border-sm text-light"
      role="status"
    ></div>
  ) : (
    "Submit Message"
  )}
</button>
              </div>
            </form>
          </div>

          {/* 🌐 SOCIAL MEDIA SECTION */}
          <div className="social-links-card  mt-4 p-3 text-center">
            <h5 className="fw-bold mb-3">Follow Us</h5>
            <div className="d-flex justify-content-center gap-3 social-icons">
              <a href="https://www.instagram.com/soulsathi_official/" target="_blank" className="social-icon instagram">
                <FaInstagram size={24} />
              </a>

              <a href="#" target="_blank" className="social-icon facebook">
                <FaFacebookF size={24} />
              </a>

              <a href="#" target="_blank" className="social-icon linkedin">
                <FaLinkedinIn size={24} />
              </a>

              <a href="#" target="_blank" className="social-icon twitter">
                <FaXTwitter size={24} />
              </a>

              <a href="#" target="_blank" className="social-icon youtube">
                <FaYoutube size={24} />
              </a>

              <a href="#" target="_blank" className="social-icon whatsapp">
                <FaWhatsapp size={24} />
              </a>
            </div>
          </div>
        </div>
      </div>

 
    </>
  );
};

export default ContactUs;
